import FieldTypes from './FieldTypes';

export default field => {
  //Defaults
  let minLength = 1;
  let maxLength = 128;

  //Special case for hex
  if (field.type === FieldTypes.HexColor) {
    return t => {
      return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(t);
    };
  }

  //If there are values in the db dictating lengths, override defaults
  if (field.validationConstraints) {
    if (field.validationConstraints.minLength)
      minLength = field.validationConstraints.minLength;
    if (field.validationConstraints.maxLength)
      maxLength = field.validationConstraints.maxLength;
  }

  return t => {
    return t.length >= minLength && t.length <= maxLength;
  };
};
